import type { SettingsSection } from "./router";

/** Presentation only: App and the API independently enforce access to every destination. */
export type ShellNavKey = "inbox" | "catalog" | "staff" | SettingsSection
  | "ruleReference" | "emailQa" | "agentRulesLab" | "businesses";
export type ShellGroupKey = "masterData" | "settings" | "quality" | "platform";

export const SHELL_GROUPS: ReadonlyArray<{ key: ShellGroupKey; icon: string; entries: readonly ShellNavKey[] }> = [
  { key: "masterData", icon: "database", entries: ["catalog", "staff"] },
  { key: "settings", icon: "settings", entries: ["setup", "email", "signature", "logo", "rule-values", "system"] },
  { key: "quality", icon: "shieldCheck", entries: ["emailQa", "agentRulesLab"] },
  { key: "platform", icon: "server", entries: ["businesses", "service-mailboxes"] },
];

export interface ShellNavAccess {
  isAdmin: boolean;
  isOwner: boolean;
  inBusiness: boolean;
  canReadRules: boolean;
  ruleValuesAvailable: boolean;
  testMailEnabled: boolean;
}

export function shellNavKeys(access: ShellNavAccess): ShellNavKey[] {
  const keys: ShellNavKey[] = [];
  if (access.inBusiness) keys.push("inbox");
  if (access.isAdmin && access.inBusiness) {
    keys.push("catalog", "staff", "setup", "email", "signature", "logo");
    if (access.ruleValuesAvailable) keys.push("rule-values");
    keys.push("system");
  }
  if (access.canReadRules) keys.push("ruleReference");
  if (access.isOwner || access.testMailEnabled) keys.push("emailQa");
  if (access.isOwner) keys.push("agentRulesLab", "businesses", "service-mailboxes");
  return keys;
}
